export default {
  name: 'Button',
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) => value === 'primary' || 'secondary',
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    link: {
      type: String,
      required: false,
    },
    target: {
      type: Boolean,
      required: false,
    },
  },
};
